"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NearbyVenuesRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class NearbyVenuesRequestDto {}
exports.NearbyVenuesRequestDto = NearbyVenuesRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "mapCenterLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "mapCenterLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  enum: enums_1.MapVersion,
  description: 'Map mode/version. Legacy returns all venues. New returns venues only when they have at least one activity stat (check-ins, events, breadcrumbs, views) or a custom logoUrl (non-null `logo_url` in DB).'
}), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "mapMode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  enum: enums_1.VenueActivityFilter,
  description: 'When `recent`, only returns venues meeting the "active" threshold (check-ins, recent check-ins, RSVPs, visit plans, breadcrumbs, or recent views) — independent of mapMode\'s logoUrl allowance.'
}), __metadata("design:type", String)], NearbyVenuesRequestDto.prototype, "activity", void 0);
//# sourceMappingURL=NearbyVenuesRequest.dto.js.map